import withHelmet from '../HOC/withHelmet';
import Share from '../components/share';

export default withHelmet(Share, 'Share with your network');
